import * as firebase from "firebase/app"
import "firebase/firestore"
import "firebase/performance"
import "firebase/auth"
import "firebase/functions"
import "firebase/storage"
import config from "./firebaseIDs"

// firebase init goes here
firebase.initializeApp(config.config)
firebase.performance()
// firebase utils
const db = firebase.firestore()
const firestore = firebase.firestore
const auth = firebase.auth()
const authh = firebase.auth
const currentUser = auth.currentUser
const functions = firebase.functions()
const storage = firebase.storage()
// date issue fix according to firebase
const settings = {
  //timestampsInSnapshots: true
}
db.settings(settings)

// firebase collections
const LocationsCollections = db.collection("Locations")
const AssetsCollections = db.collection("Assets")
const SettingsCollections = db.collection("Settings")
const SnapShotCollections = db.collection("SnapShot")
const CustomersCollections = db.collection("Customers")
const IndexCollections = db.collection("Indexs")
const LotsCollections = db.collection("Lots")
const HDDWIPECollection = db.collection("hddWipe")

export {
  db,
  auth,
  authh,
  storage,
  firestore,
  functions,
  currentUser,
  CustomersCollections,
  SnapShotCollections,
  LocationsCollections,
  AssetsCollections,
  SettingsCollections,
  IndexCollections,
  HDDWIPECollection,
  LotsCollections
}
